import { Suspense } from 'react';
import { Sidebar } from '@/common/components/sidebar/Sidebar';
import { ProductDetailSkeleton } from './ProductDetailSkeleton';
import { ProductDetailPanelContent } from './ProductDetailPanelContent';

interface ProductDetailPanelProps {
  variantId: number;
  supplyPointId: number;
  canManageProducts: boolean;
}

export function ProductDetailPanel({
  variantId,
  supplyPointId,
  canManageProducts,
}: ProductDetailPanelProps) {
  return (
    <Sidebar className="w-full sm:max-w-lg">
      <Suspense fallback={<ProductDetailSkeleton />}>
        <ProductDetailPanelContent
          variantId={variantId}
          supplyPointId={supplyPointId}
          canManageProducts={canManageProducts}
        />
      </Suspense>
    </Sidebar>
  );
}
